import { createContext } from "solid-js";

export const ReduxContext = createContext({ store: {}, state: {}, api:{} });
export default ReduxContext;